// src/hooks/useJobCosts.js
// S6B VERIFIER: s6costing-4d8a2f63 — security audit 2026-10-02 #2.
//
// Live labour cost rates from organizations/{orgId}/jobCosts (see src/utils/jobCosts.js).
// Owner / Admin / Manager only: firestore.rules denies everyone else, so callers MUST pass
// enabled = canSeeLaborCost(profile) — a disabled hook never subscribes and returns an
// empty result, and every reader falls back to the row's legacy rate (null here).
//
//   useJobCosts(orgId, jobId, enabled)  → { rates, loaded }        one job
//   useOrgJobCosts(orgId, enabled)      → { ratesByJob, loaded }   every job (reports)
import { useEffect, useState } from 'react';
import { collection, doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

export function useJobCosts(orgId, jobId, enabled = true) {
    const [state, setState] = useState({ rates: null, loaded: false });

    useEffect(() => {
        if (!enabled || !orgId || !jobId) { setState({ rates: null, loaded: false }); return undefined; }
        setState({ rates: null, loaded: false });
        return onSnapshot(
            doc(db, `organizations/${orgId}/jobCosts`, jobId),
            (snap) => setState({ rates: snap.exists() ? (snap.data().rates || null) : null, loaded: true }),
            (err) => {
                console.warn('useJobCosts: subscription failed', err);
                setState({ rates: null, loaded: true });
            }
        );
    }, [orgId, jobId, enabled]);

    return state;
}

export function useOrgJobCosts(orgId, enabled = true) {
    const [state, setState] = useState({ ratesByJob: {}, loaded: false });

    useEffect(() => {
        if (!enabled || !orgId) { setState({ ratesByJob: {}, loaded: false }); return undefined; }
        setState({ ratesByJob: {}, loaded: false });
        return onSnapshot(
            collection(db, `organizations/${orgId}/jobCosts`),
            (snap) => {
                const ratesByJob = {};
                snap.docs.forEach((d) => { ratesByJob[d.id] = d.data().rates || null; });
                setState({ ratesByJob, loaded: true });
            },
            (err) => {
                console.warn('useOrgJobCosts: subscription failed', err);
                setState({ ratesByJob: {}, loaded: true });
            }
        );
    }, [orgId, enabled]);

    return state;
}

export default useJobCosts;
